import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Bullseye, Clipboard2Check, ShieldLock } from 'react-bootstrap-icons';

/**
 * Richer landing step for the quiz — only affects the welcome phase.
 */
const QuizWelcomeHero = ({ onContinue, showArchetypesOverviewLink = false }) => {
  return (
    <div className="quiz-welcome-hero">
      <div className="quiz-welcome-hero-bg" aria-hidden />
      <div className="quiz-welcome-hero-grid" aria-hidden />

      <div className="quiz-welcome-inner">
        <p className="quiz-welcome-eyebrow">PrecisionTrader · free assessment</p>

        <h1 className="quiz-welcome-title">
          Discover your{' '}
          <span className="quiz-welcome-title-accent">trader archetype</span>
        </h1>

        <p className="quiz-welcome-deck">
          See what’s most likely slowing you down, how pitfalls usually show up for your archetype, and which
          trading rules/guardrails tend to help — honest answers only; nothing here is a grade!
        </p>

        <ul className="quiz-welcome-pillars list-unstyled">
          <li>
            <span className="quiz-welcome-pillar-icon" aria-hidden>
              <Bullseye size={22} strokeWidth={0.5} />
            </span>
            <div className="quiz-welcome-pillar-body">
              <strong className="quiz-welcome-pillar-title">Archetype fit</strong>
              <p className="quiz-welcome-pillar-desc mb-0">
                See which archetype your real trading habits align with.
              </p>
            </div>
          </li>
          <li>
            <span className="quiz-welcome-pillar-icon" aria-hidden>
              <Clipboard2Check size={22} strokeWidth={0.5} />
            </span>
            <div className="quiz-welcome-pillar-body">
              <strong className="quiz-welcome-pillar-title">Blind spots</strong>
              <p className="quiz-welcome-pillar-desc mb-0">
                How pitfalls usually show up for someone with that profile.
              </p>
            </div>
          </li>
          <li>
            <span className="quiz-welcome-pillar-icon" aria-hidden>
              <ShieldLock size={22} strokeWidth={0.5} />
            </span>
            <div className="quiz-welcome-pillar-body">
              <strong className="quiz-welcome-pillar-title">Guardrails</strong>
              <p className="quiz-welcome-pillar-desc mb-0">
                Trading rules and tools aimed at where you tend to slip.
              </p>
            </div>
          </li>
        </ul>

        <div className="quiz-welcome-cta-block">
          <Button variant="primary" size="lg" className="quiz-welcome-cta-btn px-5" onClick={onContinue}>
            Continue
          </Button>
          <div className="quiz-welcome-meta-stack">
            <p className="quiz-welcome-meta mb-0">
              ~2 min · progress saves if you refresh
            </p>
            {showArchetypesOverviewLink ? (
              <p className="quiz-welcome-meta mb-0">
                <Link to="/quiz/profiles" className="quiz-welcome-profiles-link">
                  Archetypes overview
                </Link>
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizWelcomeHero;
